<div class="admin-container">
  <div class="sections" *ngIf="selections['selectSection']">
    <div class="section" (click)="displaySection('selectTitle')">
      <div>Titre</div>
    </div>
    <div class="section">
      <div>Paragraphe</div>
      <i class="pi pi-align-center" (click)="addSection('paragraph')"></i>
    </div>
    <div class="section">
      <div>Info</div>
      <i class="pi pi-info-circle" (click)="addSection('info')"></i>
    </div>
    <div class="section">
      <div>Images</div>
      <i class="pi pi-images" (click)="addSection('picture')"></i>
    </div>
    <div class="section">
      <div>Instagram</div>
      <i class="pi pi-instagram" (click)="addSection('instagram')"></i>
    </div>
    <div class="section">
      <div>Mention</div>
      <i class="pi pi-book" (click)="addSection('mention')"></i>
    </div>
    <div class="section">
      <div>Article link</div>
      <i class="pi pi-link" (click)="addSection('articleLink')"></i>
    </div>
    <div class="section">
      <div>Iframe</div>
      <i class="pi pi-code" (click)="addSection('iframe')"></i>
    </div>
    <div class="section">
      <div>Button</div>
      <i class="pi pi-bolt" (click)="addSection('button')"></i>
    </div>
  </div>
  <div class="sections" *ngIf="selections['selectTitle']">
    <div class="section" (click)="addSection('main-title')">
      <div>Titre principal</div>
    </div>
    <div class="section" (click)="addSection('secondary-title')">
      <div>Titre secondaire</div>
    </div>
    <div class="section" (click)="addSection('third-title')">
      <div>Sous-titre</div>
    </div>
  </div>
</div>
